import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TemplateMasterService } from '../../../template-master.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DeleteTemplateComponent } from '../delete-template/delete-template.component';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
import { CategorySelectionTemplateComponent } from '../category-selection-template/category-selection-template.component';
import { CreateTemplateComponent } from '../../create-template/create-template.component';
declare var bootstrap: any;
@Component({
  selector: 'app-preview-rightside-template',
  templateUrl: './preview-rightside-template.component.html',
  styleUrls: ['./preview-rightside-template.component.scss']
})
export class PreviewRightsideTemplateComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PreviewRightsideTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private templateMasterService: TemplateMasterService,
    private snackbar: MatSnackBar,
    private router: Router,
    private eventService: EventEmmiterService
  ) {

  }
  @ViewChild('rejectionModalElement') rejectionModalElement!: ElementRef;
  @ViewChild('approveModalElement') approvalModalElement!: ElementRef;
  rejectionModal: any;
  hasPermission: boolean = false;
  approvalModal: any;
  ngOnInit() {
    // const approvalModalElement = document.getElementById('exampleModalCenter');
    // if (modalElement) {
    //   this.approvalModal = new bootstrap.Modal(approvalModalElement);
    // }
    this.dialogRef.updatePosition({ top: '0px', right: '0px' });

    this.hasPermission = localStorage.getItem('staffType') == 'ADMIN' ? true : false;
    this.v3getTemplateDetails(this.data.pageData.id)
    this.templateId = this.data.pageData.id;
    // this.templateStatus = this.data.pageData.approvalStatus;
  }
  ngAfterViewInit(): void {
    if (this.rejectionModalElement) {
      this.rejectionModal = new bootstrap.Modal(this.rejectionModalElement.nativeElement);
    }
    if (this.approvalModalElement) {
      this.approvalModal = new bootstrap.Modal(this.approvalModalElement.nativeElement);
    }
  }
  templateData: any;
  getLoader: boolean = false;
  templateId: any;
  templateStatus: any;
  rejectedReason: any;
  v3getTemplateDetails(id) {
    this.getLoader = true;
    this.templateMasterService.v3GetSingleTemplateDetails(id).subscribe(
      (res: any) => {
        console.log(res.data)
        this.templateData = res.data;
        // console.log('template data is',this.templateData)
        // console.log(this.templateData.page.pageName)
        this.getLoader = false;
      },
      (err) => {
        this.getLoader = false;
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        )
      }
    )
  }

  onStatusChange(event: any) {
    const selectedValue = event.value;
    if (selectedValue === 'REJECTED') {
      if (this.rejectionModal) {
        this.rejectionModal.show();
      }
    }
    else if (selectedValue === 'APPROVED') {
      if (this.approvalModal) {
        this.approvalModal.show();
      }
    }
  }
  deleteComponent(element: any) {
    let dialog = this.templateMasterService.openDeleteDialog(
      DeleteTemplateComponent,
      '250px',
      '350px',
      { data: element },
      '80vw'
    );
    dialog.afterClosed().subscribe((data: any) => {
      if (data) {
        this.dialogRef.close({ data: 'success' });
        this.router.navigate(['/master/template/v3-template'])
      }
    });
  }
  editComponent(element: any) {
    // console.log(element)
    this.dialogRef.close({ id: element });
    // this.router.navigate([`/master/template/view-template/${element}`])
  }

  cancel() {
    this.dialogRef.close();
    // this.close();
  }

  openCalls: any
  pageLoader: boolean = false

  changeTemplatecategory(category: 'FREE' | 'PREMIUM') {
    this.templateData.templateCategory = category;
    this.templateMasterService.updateTemplateCategory(this.templateData.id, category).subscribe((res: any) => {
      this.snackbar.open('Template category Updated', 'close', { duration: 2000 });
    })
  }

  // approveTemplate(){
  //   this.templateStatus = 'APPROVED'
  //   this.templateMasterService.changeTemplateStatus(this.templateId,this.templateStatus).subscribe((res: any) => {
  //     this.snackbar.open('Template Status Updated', 'close', {duration: 2000});
  //   })
  // }
  // rejectTemplate(){
  //   this.templateStatus = 'REJECTED'
  //   this.templateMasterService.changeTemplateStatus(this.templateId,this.templateStatus).subscribe((res: any) => {
  //     this.snackbar.open('Template Status Updated', 'close', {duration: 2000});
  //   })
  // }

  // editTemplate(item: any, type: any, btype: any,) {
  //   console.log(this.data)
  //   let openDialog = this.templateMasterService.openDialogWithData(
  //     CategorySelectionTemplateComponent,
  //     'auto',
  //     '25%',
  //     { data: this.data.pageData, edit :true }
  //   );

  //   openDialog.afterClosed().subscribe((res: any) => {
  //     if (res.data != null) {

  //       this.templateMasterService.openDialogWithData(CreateTemplateComponent, '100vh', '100%', {subIndustryId: res.data.bType.subIndustryId, subIndustryName: res.data.bType.subIndustryName, name: res.data.tempName, edit: true, websiteType: res.data.websiteType,approvalStatus:'PENDING', desc: res.data.desc})
  //     }
  //   });
  // }
  editData: any;
  editTempData: any;
  editTemplate(item: any) {
    let openDialog = this.templateMasterService.openDialogWithData(
      CategorySelectionTemplateComponent,
      'auto',
      '25%',
      { data: this.data.pageData, edit: true, }
    );

    // let bDetails: any = { type: item.type };
    // localStorage.setItem('bDetails', JSON.stringify(bDetails));

    openDialog.afterClosed().subscribe((res: any) => {
      //   this.editData = res.data;
      //   this.templateData['name'] = this.editData.tempName;
      //   this.templateData['subIndustry'] = {
      //   id: this.data.pageData.subIndustryId,
      //   name: this.data.pageData.subIndustryName
      // }
      // this.templateData['type'] = this.editData.websiteType;
      // this.templateData['desc'] = this.editData.desc;
      // this.templateData['id'] = this.data.pageData.id
      //   this.templateMasterService.createTemplateV4(this.templateData).subscribe((res: any) => {
      //   this.templateData = res.data;
      //    })
      // if (res.data != null) {

      //   this.templateMasterService.openDialogWithData(CreateTemplateComponent, '100vh', '100%', {subIndustryId: res.data.bType.subIndustryId, subIndustryName: res.data.bType.subIndustryName, name: res.data.tempName, edit: true, websiteType: res.data.websiteType,approvalStatus:'PENDING', desc: res.data.desc})
      // }
      // let bDetails: any = { type: res.data.websiteType };
      // localStorage.setItem('bDetails', JSON.stringify(bDetails));
      // this.router.navigate(['/master/template/create-template'], { queryParams: { subIndustryId: res.data.subIndustry.id, subIndustryName: res.data.subIndustry.name, name: res.data.tempName, id: res.data.id, edit: true, websiteType: res.data.websiteType, approvalStatus: 'PENDING', desc: res.data.desc } })
      // this.templateMasterService.openDialogWithData(CreateTemplateComponent, '100vh', '100%', {subIndustryId: res.data.bType.subIndustryId, subIndustryName: res.data.bType.subIndustryName, name: res.data.tempName,id: res.data.id, edit: true, websiteType: res.data.websiteType,approvalStatus:'PENDING', desc: res.data.desc})
      this.v3getTemplateDetails(this.data.pageData.id)
    });

    // this.templateMasterService.openDialogWithData(CreateTemplateComponent, '100vh', '100%',
    // {subIndustryId: res.data.bType.subIndustryId, subIndustryName: res.data.bType.subIndustryName, name: res.data.tempName, edit: true, websiteType: res.data.websiteType,approvalStatus:'PENDING', desc: res.data.desc id: item.id})


  }
  close() {
    this.dialogRef.close();
    this.eventService.updateTemplateStatus.emit({
      view: true, subIndustryId: this.data?.pageData?.subIndustry?.id ?? null
    })
  }
  updateTemplateStatus(status: 'APPROVED' | 'REJECTED' | 'PENDING') {
    this.templateStatus = status;
    this.templateMasterService.changeTemplateStatus(this.templateId, this.templateStatus, this.rejectedReason).subscribe((res: any) => {
      this.snackbar.open('Template Status Updated', 'close', { duration: 2000 });
      this.close();
    });
  }

}
